<div id="layout-wrapper">
    <app-topbar> </app-topbar>
    <app-sidebar class="hide-for-mobile"></app-sidebar>
    <div class="main-content">
        <div class="page-content">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
</div>